(function () {
  function qs(root, sel) { return root ? root.querySelector(sel) : null; }
  function qsa(root, sel) { return root ? root.querySelectorAll(sel) : []; }

  function getFormId(section) {
    var anyRadio = qs(section, "input[data-single-option-selector][form]");
    if (anyRadio && anyRadio.getAttribute("form")) return anyRadio.getAttribute("form");

    var form = qs(section, "form.product-form[id^='ProductForm--']");
    return form && form.getAttribute("id") ? form.getAttribute("id") : ""; // PERF 04-10 (F2a-3): form.id devolvia o <input name="id"> do form
  }

  function getVariantIdInput(section, formId) {
    if (!formId) return null;

    // fora do form, ligado via form="FORM_ID"
    var outside = section.querySelector("input[name='id'][form='" + formId.replace(/'/g,"\\'") + "']");
    if (outside) return outside;

    // dentro do form
    var form = section.querySelector("form#" + (window.CSS && CSS.escape ? CSS.escape(formId) : formId));
    if (form) return qs(form, "input[name='id'], select[name='id']");

    return null;
  }

  function readVariantId(section) {
    var formId = getFormId(section);
    var el = getVariantIdInput(section, formId);
    return el && el.value ? String(el.value) : "";
  }

  function renderRoot(root, vid) {
    if (!root || !vid) return;

    // PERF 30-09 (G-a) G2 — templates deduplicados: data-variant-ids="id id ..."; fallback ao formato antigo data-variant-id.
    // Reverter: repor a linha var tpl = root.querySelector('template[data-variant-id="' + (...) + '"]');
    var esc = (window.CSS && CSS.escape) ? CSS.escape(vid) : vid;
    var tpl = root.querySelector('template[data-variant-ids~="' + esc + '"]')
           || root.querySelector('template[data-variant-id="' + esc + '"]');
    var content = root.querySelector('[data-vamf-content]');
    var details = root.querySelector('details.accordion');
    if (!content || !details) return;

    var html = tpl ? (tpl.innerHTML || "").trim() : "";

    // esconder por completo se vazio
    if (!html) {
      root.hidden = true;
      details.hidden = true;
      // não limpar sempre para evitar trabalho desnecessário
      if ((content.innerHTML || "").trim() !== "") content.innerHTML = "";
      return;
    }

    root.hidden = false;
    details.hidden = false;

    // evita re-render se igual
    if ((content.innerHTML || "").trim() === html) return;

    content.innerHTML = html;
  }

  function initSection(section) {
    if (!section || section.__vamfInit) return;
    section.__vamfInit = true;

    function renderAll(force) {
      var vid = readVariantId(section);
      if (!vid) return;

      // só atualizar se mudou (salvo force)
      if (!force && section.__vamfLastVid === vid) return;
      section.__vamfLastVid = vid;

      qsa(section, "[data-vamf-root]").forEach(function (root) {
        renderRoot(root, vid);
      });
    }

    // inicial
    renderAll(true);

    // eventos de mudança de variante (Broadcast radios/swatch)
    section.addEventListener("change", function (e) {
      if (!e.target) return;

      var name = e.target.name || "";
      var isOption =
        e.target.matches("input[data-single-option-selector], select[data-single-option-selector]") ||
        name.indexOf("options[") === 0 ||
        name.indexOf("options[") > -1;

      if (isOption) {
        setTimeout(function(){ renderAll(true); }, 0);
        setTimeout(function(){ renderAll(true); }, 60);
      }
    }, true);

    section.addEventListener("click", function (e) {
      if (e.target && (e.target.closest("[data-variant-buttons]") || e.target.closest(".radio__buttons"))) {
        setTimeout(function(){ renderAll(true); }, 0);
        setTimeout(function(){ renderAll(true); }, 60);
      }
    }, true);

    // PERF 03-10 (F1): a verificacao de 600 ms deixou de correr para sempre. Corre so numa janela: ate 4 s depois
    // do load e 3 s depois de cada interaccao/troca de variante (ver armarVigia). Reverter: repor o setInterval
    // de 600 ms sem prazo (var intervalId = setInterval(function(){...renderAll(false);}, 600);).
    section.__vamfTick = function () {
      // se a secção foi removida (AJAX), pára
      if (!document.body.contains(section)) return false;
      // se o tab não está visível, não gastar CPU
      if (document.hidden) return true;
      renderAll(false);
      return true;
    };
    armarVigia(document.readyState === 'complete' ? 4000 : 0);
  }

  // PERF 03-10 (F1): um so timer para todas as seccoes, so enquanto ha janela aberta.
  var vigiaId = null, vigiaAte = 0, esperaLoad = document.readyState !== 'complete';
  function armarVigia(ms) {
    vigiaAte = Math.max(vigiaAte, Date.now() + ms);
    if (vigiaId) return;
    vigiaId = setInterval(function () {
      var vivas = 0;
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function (s) { if (s.__vamfTick && s.__vamfTick()) vivas++; });
      if (!vivas || (!esperaLoad && Date.now() > vigiaAte)) { clearInterval(vigiaId); vigiaId = null; }
    }, 600);
  }
  if (esperaLoad) window.addEventListener('load', function () { esperaLoad = false; armarVigia(4000); }, { once: true });
  ['click', 'change', 'input', 'keydown', 'touchend'].forEach(function (t) {
    document.addEventListener(t, function () { armarVigia(3000); }, { capture: true, passive: true });
  });
  ['popstate', 'pageshow'].forEach(function (t) { window.addEventListener(t, function () { armarVigia(3000); }); });
  document.addEventListener('theme:variant:change', function () { armarVigia(3000); });

  function initAll() {
    // só sections que tenham os teus accordions
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (section) {
      if (qs(section, "[data-vamf-root]")) initSection(section);
    });
  }

  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:select", initAll);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();